<template>
  <ib-dialog
    :visible="visible"
    :closable="false"
    empty-header
    top="8vh"
    width="850px"
    @close="skip"
  >
    <!-- Quick Tour -->
    <idea-score-quick-tour video-height="250" />
    <!-- Quick Tour -->

    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :submit-btn-text="$t('upgradeToContinue')"
        :cancel-btn-text="$t('back')"
        :visible-submit-btn="subscriptionIsDreamer || subscriptionIsFreeTrial"
        @submit="submit"
        @cancel="skip"
      />
    </template>
  </ib-dialog>
</template>

<script>
import IdeaScoreQuickTour from '@/views/Home/Components/QuickTours/IdeaScoreQuickTour.vue'
import MixinUserSubscription from '@/mixins/permissions/userSubscription'
import { mapMutations } from 'vuex'

export default {
  name: 'DialogIdeaScoreQuickTour',

  components: { IdeaScoreQuickTour },

  mixins: [MixinUserSubscription],

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapMutations('app', ['setRedirectRouteAfterPayment']),

    submit () {
      this.setRedirectRouteAfterPayment(this.$route.name)
      this.$router.push({ name: 'payment' })
    },

    skip () {
      this.$emit('skip')
      if (this.subscriptionIsFreeTrial || this.subscriptionIsDreamer) {
        this.$router.go(-1)
      }
    }
  }
}
</script>
